import * as React from 'react';

const InfoOutlined = props => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 22 22"
    stroke="none"
    strokeWidth={1}
    fillRule="nonzero"
    fill="#FFFFFF"
    {...props}>
    <path
      fill="#808FC5"
      d="M11,0 C4.925,0 0,4.925 0,11 C0,17.075 4.925,22 11,22 C17.075,22 22,17.075 22,11 C22,4.925 17.075,0 11,0 Z M11,2 C15.971,2 20,6.029 20,11 C20,15.971 15.971,20 11,20 C6.029,20 2,15.971 2,11 C2,6.029 6.029,2 11,2 Z"
    />
    <path d="M10,15 C10,15.552 10.448,16 11,16 C11.552,16 12,15.552 12,15 L12,11 C12,10.448 11.552,10 11,10 C10.448,10 10,10.448 10,11 L10,15 Z" />
    <circle fillRule="evenodd" cx={11} cy={7} r={1} />
  </svg>
);

export default InfoOutlined;



// WEBPACK FOOTER //
// ./src/assets/images/icons/info-outlined.js